import { customerv6Url } from '../api-urls';

export function createRequestUpdateCustomer(id, token, customer) {
  return {
    url: `${customerv6Url}/${id}`,
    method: 'post',
    data: customer,
    headers: {
      'access-token': token
    }
  };
}
